import React from 'react';
import { BaseDesignRegistrationPanelProps, DesignRegistrationPanel } from 'common/components';
import { INTERIOR_DOORS_ELEMENT_BLOCK } from '../../interior-doors-constants';
import { INTERIOR_DOORS_PANEL_STRUCTURE } from './interior-doors-design-panel-constants';

export const InteriorDoorsDesignPanel: React.FC<BaseDesignRegistrationPanelProps> = ({
  isConsultationFormVisible,
  onConsultationSignupBtnClick,
}) => (
  <DesignRegistrationPanel
    isConsultationFormVisible={isConsultationFormVisible}
    structure={{
      panel: {
        ...INTERIOR_DOORS_PANEL_STRUCTURE.panel,
        actionBlock: [
          {
            elementBlock: INTERIOR_DOORS_ELEMENT_BLOCK,
            label: 'Записаться на консультацию',
            onClick: onConsultationSignupBtnClick,
            variant: 'accent',
          },
        ],
      },
      mobilePanel: {
        ...INTERIOR_DOORS_PANEL_STRUCTURE.mobilePanel,
        mobileButton: {
          ...INTERIOR_DOORS_PANEL_STRUCTURE.mobilePanel.mobileButton,
          onClick: onConsultationSignupBtnClick,
        },
      },
    }}
  />
);
